import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import toast from "react-hot-toast";
import { adminApi } from "../../services/api";
import AdminPanel from "../../components/admin/AdminPanel";
import AdminTable from "../../components/admin/AdminTable";
import AdminStatus from "../../components/admin/AdminStatus";
import AdminFilter from "../../components/admin/AdminFilter";
import useAdminData from "../../components/admin/useAdminData";
import { unwrap, params, formatDate } from "../../components/admin/adminFormat";
import Button from "../../components/Button";

export default function Users() {
  const { t } = useTranslation();
  const { locale } = useOutletContext();
  const [form, setForm] = useState({ search: "", active: "", countryCode: "" });
  const [query, setQuery] = useState({});
  const { data, setData, loading } = useAdminData(async () => unwrap(await adminApi.getUsers(query)), [query]);
  const users = data || [];

  const toggle = async (item) => {
    try {
      const updated = unwrap(await adminApi.updateUserStatus(item.id, !item.active));
      setData(users.map((user) => (user.id === updated.id ? updated : user)));
      toast.success(t("admin.status_updated"));
    } catch (error) {
      toast.error(error.response?.data?.message || t("admin.request_error"));
    }
  };

  return (
    <>
      <AdminFilter
        t={t} form={form} setForm={setForm} fields={["search", "active", "countryCode"]}
        submit={() => setQuery(params({ ...form, active: form.active === "" ? undefined : form.active === "true" }))}
      />
      <AdminPanel>
        {loading ? t("common.loading") : (
          <AdminTable
            t={t}
            headers={[t("admin.user"), t("admin.country"), t("admin.date"), t("admin.status"), t("admin.action")]}
            rows={users.map((item) => [
              <><strong>{item.firstName} {item.lastName}</strong><br /><small>{item.email || item.phoneNumber}</small></>,
              item.countryCode,
              formatDate(item.createdAt, locale),
              <AdminStatus key="s" active={item.active} t={t} />,
              <Button key="b" size="sm" variant={item.active ? "danger" : "primary"} onClick={() => toggle(item)}>
                {item.active ? t("admin.deactivate") : t("admin.activate")}
              </Button>,
            ])}
          />
        )}
      </AdminPanel>
    </>
  );
}
